import { atom, useAtom } from "jotai";
import { ResidenceCategoryFilterModel } from "../../clients/KompasApi";
import { Box, Text } from "@chakra-ui/react";
import { Multiselect } from "../Multiselect";

export const residenceCategoryIdsAtom = atom<number[]>([]);

interface Props {
  options: ResidenceCategoryFilterModel[];
  value: ResidenceCategoryFilterModel[];
}

export function ResidenceCategoryFilter({ options, value }: Props) {
  const [, setResidenceCategoryIds] = useAtom(residenceCategoryIdsAtom);

  if (!options.length) return null;

  return (
    <Box>
      <Text fontSize="sm" fontWeight="500">
        Woningcategorie
      </Text>
      <Multiselect
        items={options}
        onChange={(v) => setResidenceCategoryIds(v.map((i) => i.id))}
        value={value}
      />
    </Box>
  );
}
